import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateOrderBatch(
    $scopeId: Int!
    $scopeType: String!
    $paymentAccountPaysProcessingFee: Boolean!
    $allowOfflineCheckout: Boolean!
    $paymentAccountId: Int!
    $userIds: Int
    $dueDate: String!
    $orderLineItems: [CreateOrderBatchLineItemInput]!
  ) {
    createOrderBatch(
      input: {
        scopeId: $scopeId
        scopeType: $scopeType
        paymentAccountPaysProcessingFee: $paymentAccountPaysProcessingFee
        allow_offline_checkout: $allowOfflineCheckout
        payment_account_id: $paymentAccountId
        user_ids: $userIds
        due_date: $dueDate
        order_line_items: $orderLineItems
      }
    ) {
      id
    }
  }
`;
